module.exports = __webpack_public_path__ + "prize-light.bf804909.png";